import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const MainBodyLayout = ({
  children = null,
  withBack = false,
  onPrevClick = null,
  withInfoIcon = false,
  title = null,
  className = '',
}) => {
  const history = useHistory();

  const closeCardOrder = () => history.push('/dashboard/card');

  return (
    <div className={`d-flex flex-column main-layout-body-container ${className} main-body-layout`}>
      {(withBack || withInfoIcon) && (
        <div className="d-flex flex-row justify-content-between align-items-center px-3 px-md-0">
          {withBack && (
            <div
              className="cursor-pointer text-hover"
              onClick={onPrevClick}
              onKeyDown={onPrevClick}
              role="presentation">
              <i className="icon icon-arrow_back-navigation text-f5 me-2" aria-label="Back" />
            </div>
          )}
          {!withBack && withInfoIcon && (
            <>
              {/* mobile */}
              <p className="d-block d-md-none text-dark text-f4">{title}</p>
              {/* browser */}
              <p className="d-none d-md-block text-dark text-f3">{title}</p>
            </>
          )}
          <div className="d-flex flex-row align-items-center ">
            {withInfoIcon && (
              <>
                <div
                  className="cursor-pointer text-hover"
                  onClick={() => {}}
                  onKeyDown={() => {}}
                  role="presentation">
                  {/* mobile */}
                  <i
                    className="d-block d-md-none icon icon-question-other text-shadow"
                    style={{ fontSize: '1.7rem' }}
                  />

                  {/* browser */}
                  <i
                    className="d-none d-md-block icon icon-question-other text-shadow"
                    style={{ fontSize: '1.2rem' }}
                  />
                </div>
              </>
            )}
            {/* mobile only */}
            <div
              className="d-md-none"
              onClick={closeCardOrder}
              onKeyDown={closeCardOrder}
              role="button"
              tabIndex={-1}>
              <i
                className="close-btn cursor-pointer icon icon-close-other text-dark text-f4 ms-2"
                aria-label="Close"
              />
            </div>
          </div>
        </div>
      )}
      {/* {withBack && withInfoIcon && title && ( */}
      <div className="d-flex flex-row justify-content-start align-items-center mt-3 px-3 mt-md-4 px-md-0">
        {/* mobile */}
        <p className="d-block d-md-none text-dark text-f4">{title}</p>
        {/* browser */}
        <p className="d-none d-md-block text-dark text-f3">{title}</p>
      </div>
      {/* )} */}
      {children}
    </div>
  );
};

export default MainBodyLayout;

MainBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  withInfoIcon: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  onPrevClick: PropTypes.func,
};
